<template>
  <div class="container tem007">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne class="-margin-md">ご登録口座へのお振込み</HeadingOne>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="2" type="mb"></MainWizard>
    </WizardGroup>

    <NoticeBox class="-success _mb-md-30 _mb-sm-15">
      <NoticeHeader>
        <h3 class="heading">
          お申し込みを受け付けました。<br />※お振込みは完了しておりませんのでご注意ください。
        </h3>
      </NoticeHeader>
      <NoticeBody
        >お振込み結果については、メールにてお知らせいたしますのでご確認ください。</NoticeBody
      >
    </NoticeBox>

    <p class="_mb-0">＜ご注意＞</p>
    <p class="txt01">
      ご利用されている金融機関が営業時間外の場合にはお振込みができませんので、お手続き完了後にメールおよび会員さま専用サイトのメッセージにてお知らせいたします。その際、お申し込みは予約扱いにはなりません。
    </p>
    <p class="txt01">
      お急ぎの場合は、その他のお借り入れ方法をご利用ください。
    </p>
    <small class="txt01"
      >※ご利用されている金融機関の営業時間は会員さまにてご確認ください。</small
    >

    <TableBox class="_mb-md-60 _mb-sm-25 _mt-40">
      <TableBody>
        <TableRow>
          <TableHeader> ご登録の口座 </TableHeader>
          <TableData class="-pctextright">
            金融機関名：{{ userData.bank_name }}<br />
            支店名：{{ userData.branch_name }}
          </TableData>
        </TableRow>
        <TableRow>
          <TableHeader> お借り入れ金額 </TableHeader>
          <TableData class="-pctextright">
            {{ numberToCurrency(userData.amount * 10000) }}
          </TableData>
        </TableRow>
      </TableBody>
    </TableBox>

    <BtngroupSingle class="_mb-md-120 _mb-sm-40">
      <BtnMain class="-normal" router-name="mb001">
        会員さま専用サイトトップへ
      </BtnMain>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { getUserDataLambdaInvoke } from "@/utils/LambdaHelper";
import { numberToCurrency } from "@/utils/Filter";
import { setMeta } from "@/utils/Meta";

import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Tem007",
  components: {
    BtnMain,
    BtngroupSingle,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    NoticeBody,
    NoticeHeader,
    NoticeBox,
    MainWizard,
    WizardGroup,
    HeadingOne,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "ご登録口座へのお振込み｜お借り入れ",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,指定口座,振込",
    });

    return {
      numberToCurrency,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "ご登録口座へのお振込み",
          active: true,
        },
      ],
      errors: null,
      userData: {
        bank_name: "",
        branch_name: "",
        amount: "",
      },
    };
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          this.goToErrorPage(error);
        });
    } catch (e) {
      this.goToErrorPage(e);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.tem007 {
  > .txt01 {
    color: $danger;
  }
  .-underline {
    text-decoration: underline;
  }
}
</style>
